// axios请求方法（get、post等）封装
import { isNull, isUndefined } from 'lodash'

export const get = (axios, url = '', params = {}, useCache = {}, headers = {}) => {
  // let for(headers)
  // if(headers) axios.defaults.headers
  if (Object.keys(headers).length > 0) {
    // for (const key in headers) {
    //   console.log(key + ':' + headers[key])
    //   // axios.defaults
    // }
    // axios.create({ headers })
    // axios.defaults.headers = headers
    Object.assign(axios.defaults.headers, headers)
    // console.log(axios.create().interceptors.request, 123)
    url = url + '?'
    for (const key in params) {
      if (params[key]) {
        url += `${key}=${params[key]}&`
      }
    }
    return axios({ url, headers, useCache })
  }
  return axios.get(url, { params, headers, useCache })
}

export const post = (axios, url = '', data = {}, useCache = {}, headers = {}) => {
  return axios.post(url, data, {
    headers,
    useCache
  })
}

export const postv3 = (axios, url = '', data = {}, useCache = {}, _headers = {}) => {
  // console.log(_headers, 3334, data, 222, useCache)
  return axios.post(url, data, {
    headers: _headers,
    useCache
  })
}

/**
 * 从缓存中获取数据
 * @param cacheModel
 * @param config
 * @returns {*|boolean}
 */
export const getCacheDataByKey = (cacheModel, config = {}) => {
  if (isUndefined(cacheModel) || isNull(cacheModel)) return false
  // 不使用缓存
  if (!cacheModel.isUseCache) return false
  // 获取缓存数据
  const cacheKey = cacheModel.createApiKey(config)
  if (typeof cacheKey === 'boolean' && !cacheKey) return false
  // 请求取消并且返回缓存里面的值
  if (cacheModel.isInCache(cacheKey) && cacheModel.matchCacheCondition(config)) {
    // console.log(config.useCache, 444, cacheModel.matchCacheCondition(config))
    const cacheData = cacheModel.getDataByKey(cacheKey)
    if (cacheData.expireTime && cacheModel.isTimeOver(cacheData.expireTime)) {
      // console.log('缓存已过期，正在删除 ====>111', cacheKey)
      cacheModel.removeByKey(cacheKey)
    } else {
      // const cachelen = cacheModel.cache.keyList.filter(item => item)
      // console.log('正在使用缓存 ====>222', config.useCache && config.useCache.key)
      // console.log('cachelen', cachelen)
      return cacheData.data
    }
  }
  return false
}

/**
 * 设置缓存
 * @param cacheModel
 * @param config
 * @param cacheData
 */
export const setApiCache = (cacheModel, config, cacheData) => {
  if (isUndefined(cacheModel) || isNull(cacheModel)) return
  // 不使用缓存
  if (!cacheModel.isUseCache) return
  const cacheKey = cacheModel.createApiKey(config, true)
  if (typeof cacheKey === 'boolean' && !cacheKey) return
  if (!cacheModel.isInCache(cacheKey) && cacheModel.matchCacheCondition(config)) {
    const expireTime = cacheModel.expireDate(config)
    const data = typeof expireTime === 'boolean' ? { data: cacheData } : { data: cacheData, expireTime }
    cacheModel.setCacheByKeyAndData(cacheKey, data)
    // console.log('正在存储缓存=======>333', config.useCache && config.useCache.key)
  }
}
